export default "__VITE_ASSET__DIfD2oag__"